import * as angular from 'angular';

function alertDismissable($localStorage, $sessionStorage) {
    return {
        restrict: 'E',
        transclude: true,
        scope: {
            id: '@id',
            title: '@title',
            class: '@class'
        },
        link: (scope: any, element, attrs) => {
            scope.$localStorage = $localStorage;
            scope.$sessionStorage = $sessionStorage;
            scope.key = `alert_${scope.id}_closed`;
        },
        template: '/ngapp/template/alertDismissable.html'
    };
}

export default angular.module('directives.alertDismissable', [])
    .directive('alertDismissable', alertDismissable)
    .name;
